let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    currentSequence = [],
    playerSequence = [],
    round = 1,
    score = 0,
    lives = 3,
    isShowingSequence = false,
    isPlayerTurn = false,
    audioContext = null;

class SequenceGame {
    constructor() {
        this.startScreen = document.querySelector('[data-phase="start"]');
        this.playScreen = document.querySelector('[data-phase="play"]');
        this.resultScreen = document.querySelector('[data-phase="result"]');

        this.buttonsGrid = document.querySelector('.game__sequence-buttons-grid');
        this.messageEl = document.querySelector('[data-game-message]');
        this.roundEl = document.querySelector('[data-round]');
        this.scoreEl = document.querySelector('[data-score]');
        this.livesEl = document.querySelector('[data-lives]');

        // Pobierz dane z window
        if (window.sequenceGameData) {
            gameData = window.sequenceGameData;
            lives = gameData.lives;
        }

        // Inicjalizacja audio context
        this.initAudioContext();

        this.init();
    }

    initAudioContext() {
        try {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
        } catch (e) {
            console.warn('Web Audio API not supported');
        }
    }

    init() {
        // Event listener dla startu gry
        const startButton = document.querySelector('[data-start-game]');
        if (startButton) {
            startButton.addEventListener('click', () => this.startGame());
        }

        // Event listeners dla przycisków
        if (this.buttonsGrid) {
            const buttons = this.buttonsGrid.querySelectorAll('.sequence-button');
            buttons.forEach(button => {
                button.addEventListener('click', () => this.handleButtonClick(button));
            });
        }
    }

    startGame() {
        // Ukryj ekran startowy
        if (this.startScreen) {
            this.startScreen.classList.add('hidden');
        }

        // Pokaż ekran gry
        if (this.playScreen) {
            this.playScreen.classList.remove('hidden');
        }

        // Reset zmiennych
        currentSequence = [];
        playerSequence = [];
        round = 1;
        score = 0;
        lives = gameData.lives;

        this.updateUI();
        this.newRound();
    }

    newRound() {
        playerSequence = [];
        isPlayerTurn = false;

        // Dodaj nowy element do sekwencji
        const randomButton = Math.floor(Math.random() * gameData.buttons.length);
        currentSequence.push(randomButton);

        this.updateMessage('Obserwuj sekwencję...');

        // Wyświetl sekwencję po krótkiej przerwie
        setTimeout(() => {
            this.showSequence();
        }, 1000);
    }

    showSequence() {
        isShowingSequence = true;
        this.disableButtons();

        let index = 0;

        const showNext = () => {
            if (index < currentSequence.length) {
                const buttonId = currentSequence[index];
                this.lightButton(buttonId);
                index++;
                setTimeout(showNext, gameData.speed + 300);
            } else {
                // Sekwencja pokazana, kolej gracza
                isShowingSequence = false;
                isPlayerTurn = true;
                this.enableButtons();
                this.updateMessage('Twoja kolej! Powtórz sekwencję');
            }
        };

        showNext();
    }

    lightButton(buttonId) {
        const button = this.buttonsGrid.querySelector('[data-button-id="' + buttonId + '"]');
        if (!button) return;

        button.classList.add('active');

        // Odtwórz dźwięk
        const frequency = parseInt(button.dataset.frequency);
        this.playSound(frequency);

        setTimeout(() => {
            button.classList.remove('active');
        }, gameData.speed);
    }

    playSound(frequency) {
        if (!audioContext) return;

        try {
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.frequency.value = frequency;
            oscillator.type = 'sine';

            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.5);
        } catch (e) {
            console.warn('Sound playback error:', e);
        }
    }

    handleButtonClick(button) {
        if (!isPlayerTurn || isShowingSequence) return;

        const buttonId = parseInt(button.dataset.buttonId);

        // Podświetl przycisk
        button.classList.add('active');
        const frequency = parseInt(button.dataset.frequency);
        this.playSound(frequency);

        setTimeout(() => {
            button.classList.remove('active');
        }, 300);

        // Dodaj do sekwencji gracza
        playerSequence.push(buttonId);

        // Sprawdź czy poprawny
        const currentIndex = playerSequence.length - 1;

        if (playerSequence[currentIndex] !== currentSequence[currentIndex]) {
            // Błąd!
            this.handleWrongAnswer();
        } else {
            // Dobra odpowiedź
            if (playerSequence.length === currentSequence.length) {
                // Cała sekwencja poprawna!
                this.handleCorrectSequence();
            }
        }
    }

    handleCorrectSequence() {
        isPlayerTurn = false;

        // Punkty za rundę
        score += round * 10;
        round++;

        this.updateUI();
        this.updateMessage('Świetnie! Następna runda...');

        // Flash zielony
        gameFrame.style.borderColor = 'green';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Dźwięk sukcesu
        if (audio && audio.valid) {
            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 1000);
        }

        // Następna runda
        setTimeout(() => {
            this.newRound();
        }, 2000);
    }

    handleWrongAnswer() {
        isPlayerTurn = false;

        // Odejmij życie
        if (gameData.lives > 0) {
            lives--;
            this.updateUI();
        }

        // Flash czerwony
        gameFrame.style.borderColor = 'red';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Dźwięk błędu
        if (audio && audio.wrong) {
            audio.wrong.play();
            stopAudioAfterDelay(audio.wrong, 1000);
        }

        // Sprawdź czy koniec gry
        if (gameData.lives > 0 && lives <= 0) {
            this.updateMessage('Koniec żyć! Koniec gry');
            setTimeout(() => {
                this.endGame();
            }, 2000);
        } else {
            this.updateMessage('Błąd! Spróbuj ponownie...');
            playerSequence = [];

            // Pokaż sekwencję ponownie
            setTimeout(() => {
                this.showSequence();
            }, 2000);
        }
    }

    disableButtons() {
        const buttons = this.buttonsGrid.querySelectorAll('.sequence-button');
        buttons.forEach(btn => {
            btn.disabled = true;
            btn.classList.add('disabled');
        });
    }

    enableButtons() {
        const buttons = this.buttonsGrid.querySelectorAll('.sequence-button');
        buttons.forEach(btn => {
            btn.disabled = false;
            btn.classList.remove('disabled');
        });
    }

    updateUI() {
        if (this.roundEl) {
            this.roundEl.textContent = round;
        }
        if (this.scoreEl) {
            this.scoreEl.textContent = score;
        }
        if (this.livesEl) {
            this.livesEl.textContent = lives;

            // Zmień kolor gdy mało żyć
            if (lives <= 1) {
                this.livesEl.style.color = '#f45c43';
            } else if (lives <= 2) {
                this.livesEl.style.color = '#FFA500';
            }
        }
    }

    updateMessage(text) {
        if (this.messageEl) {
            this.messageEl.textContent = text;
        }
    }

    endGame() {
        // Ukryj ekran gry
        if (this.playScreen) {
            this.playScreen.classList.add('hidden');
        }

        // Pokaż ekran wyniku
        if (this.resultScreen) {
            this.resultScreen.classList.remove('hidden');
        }

        // Ustaw wyniki
        const finalScore = document.querySelector('[data-final-score]');
        const finalRound = document.querySelector('[data-final-round]');

        if (finalScore) {
            finalScore.textContent = score;
        }
        if (finalRound) {
            finalRound.textContent = round - 1;
        }

        // Zapisz wynik do leaderboard
        if (gameData.leaderboardEnabled) {
            this.saveScore();
            this.loadLeaderboard();
        }

        // Dźwięk końcowy
        if (audio && audio.success) {
            audio.success.play();
            stopAudioAfterDelay(audio.success, 3000);
        }
    }

    saveScore() {
        const playerName = prompt('Podaj swoje imię do tabeli wyników:', 'Gracz');
        if (!playerName) return;

        const scores = this.getLeaderboard();
        scores.push({
            name: playerName,
            score: score,
            round: round - 1,
            date: new Date().toISOString()
        });

        // Sortuj i zostaw top 10
        scores.sort((a, b) => b.score - a.score);
        const top10 = scores.slice(0, 10);

        localStorage.setItem('sequence_game_' + gameData.postId, JSON.stringify(top10));
    }

    getLeaderboard() {
        const stored = localStorage.getItem('sequence_game_' + gameData.postId);
        return stored ? JSON.parse(stored) : [];
    }

    loadLeaderboard() {
        const leaderboardEl = document.querySelector('[data-leaderboard]');
        if (!leaderboardEl) return;

        const scores = this.getLeaderboard();

        if (scores.length === 0) {
            leaderboardEl.innerHTML = '<div class="leaderboard-empty">Brak wyników</div>';
            return;
        }

        let html = '<div class="leaderboard-table">';
        html += '<div class="leaderboard-header">';
        html += '<span class="lb-rank">#</span>';
        html += '<span class="lb-name">Imię</span>';
        html += '<span class="lb-score">Wynik</span>';
        html += '<span class="lb-round">Runda</span>';
        html += '</div>';

        scores.forEach((entry, index) => {
            const isCurrentScore = entry.score === score && index === scores.findIndex(s => s.score === score);
            html += '<div class="leaderboard-row' + (isCurrentScore ? ' current-score' : '') + '">';
            html += '<span class="lb-rank">' + (index + 1) + '</span>';
            html += '<span class="lb-name">' + this.escapeHtml(entry.name) + '</span>';
            html += '<span class="lb-score">' + entry.score + '</span>';
            html += '<span class="lb-round">' + entry.round + '</span>';
            html += '</div>';
        });

        html += '</div>';
        leaderboardEl.innerHTML = html;
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    restart() {
        // Reset ekranów
        if (this.startScreen) {
            this.startScreen.classList.remove('hidden');
        }
        if (this.playScreen) {
            this.playScreen.classList.add('hidden');
        }
        if (this.resultScreen) {
            this.resultScreen.classList.add('hidden');
        }

        // Reset zmiennych
        currentSequence = [];
        playerSequence = [];
        round = 1;
        score = 0;
        lives = gameData.lives;
        isShowingSequence = false;
        isPlayerTurn = false;

        // Reset UI
        this.updateUI();
        gameFrame.style.borderColor = 'black';
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--sequence');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new SequenceGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-sequence.js